<template>
  <div class="commonDialogBody">
       <RoleManagementOneDialog @AllData="getMsgFormSon"  ref="RoleManagementOneDialog" />
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="60%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:40%;margin-left:10%;">
<el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign" >
  <el-form-item label="归属机构">
    <el-input v-model="affiliation" size="small" disabled ></el-input>
    <el-button @click="handleChange">配置</el-button>
  </el-form-item>
    <el-form-item label="角色名称" >
      <el-input v-model="roleName" size="small" ></el-input>
    </el-form-item>
    <el-form-item label="数据范围">
     <el-select  clearable v-model="dataScopeS" size="small"  @change="dataScopeChange(dataScope)" placeholder="请选择数据范围">
          <el-option
           v-for="item in dataScopeList"
          :key="item.id"
          :label="item.label"
          :value="item.id">
          </el-option>
      </el-select>
    </el-form-item>
    <div style="width:604px;height:504px;">
      <div style="float:left;width:300px;height:500px;overflow-y: scroll;">
         <el-tree
        :data="menuTree"
        accordion
        ref="MenuTreeS"
        :props="defaultPropsMenuTree"
        node-key="id"
        :default-expanded-keys="['1']"
        show-checkbox
        @check="MenuTreeCurrent"
        class="ElTree">
    </el-tree>
      </div>
       <div style="float:left;width:300px;height:500px;overflow-y: scroll;" v-if="dataScopeIf">
      <el-tree
        :data="osData"
        accordion
        ref="osDataS"
        :props="defaultProps"
        node-key="officeId"
        :default-expanded-keys="['1']"
        @check="osDataCurrent"
        show-checkbox
        class="ElTree">
    </el-tree>
       </div>
    </div>
</el-form>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"  @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import RoleManagementOneDialog from "../common/RoleManagementOneDialog.vue";
export default {
  components: {RoleManagementOneDialog},
  name: "RoleManagementDialog",
  data() {
    return {
      osData: [],
      AllDate:"",
      defaultProps: { children: 'children', label: 'officeName' },
      menuTree:[],
      defaultPropsMenuTree:{ children: 'children', label: 'name'},

      dialogVisible: false,
      title:"标题",
      labelPosition:'right',
      formLabelAlign:{},
      roleName:"",
      detection:"",
      office:{},
      affiliation:"",
      dataScopeS:[],
      dataScopeIf:true,
      dataScopeList:[
        {
          "id":"1",
          "label":"所有数据",
        },{
          "id":"2",
          "label":"所在公司及以下数据",
        },{
          "id":"3",
          "label":"所在公司数据",
        },{
          "id":"4",
          "label":"所在部门及以下数据",
        },{
          "id":"5",
          "label":"所在部门数据",
        },{
          "id":"6",
          "label":"所在项目及以下数据",
        },{
          "id":"7",
          "label":"所在小区及以下数据",
        },{
          "id":"8",
          "label":"仅本人数据",
         },{
           "id":"9",
          "label":"按明细设置",
        },
      ],
      MenuTreeChecked:[],
      osDataChecked:[],
      offices:[],
      menus:[],
      CurrentMenu:[],
      CurrentosData:[],
    };
  },
  	watch: {
		dialogVisible(val) {
			if (val == true) {
        this.CurrentMenu = []
        this.CurrentosData = []
        this.affiliation = this.formLabelAlign.row.officeName
        this.dataScopeS = this.formLabelAlign.row.dataScope
        this.roleName = this.formLabelAlign.row.roleName
        this.menus = this.formLabelAlign.roleDetails.menus
        this.offices = this.formLabelAlign.roleDetails.offices
        this.circulation(this.offices)
        for(let val of this.menus){
          val.id = val.menuId
        }
        this.traverse(this.menus)
         let arr = []
        for(let val  of this.menus){
          arr.push(val.menuId)
        }
        this.CurrentMenu = arr
            let array = []
        for(let val  of this.offices){
          array.push(val.officeId)
        }
        this.CurrentosData = array
			}
		},
    dataScope(val){
      if(val == "9"){
        this.dataScopeIf = true
      }else{
        this.dataScopeIf = false
      }
    },
	},
  methods: {
    circulation(data){
      let that = this
      setTimeout(function() {
        data.forEach(value => {
          that.$refs.osDataS.setChecked(value, true, false);
        });
      }, 300);
    },
    traverse(data){
      let that = this
      setTimeout(function() {
        data.forEach(value => {
          that.$refs.MenuTreeS.setChecked(value, true, false);
        });
      }, 300);
    },
    MenuTreeCurrent(checkedNodes,checkedKeys,halfCheckedNodes,halfCheckedKeys){
      let arr =  checkedKeys.halfCheckedKeys
      let array = arr.concat(checkedKeys.checkedKeys)
      console.log(array)
      this.CurrentMenu = array
    },
    osDataCurrent(checkedNodes,checkedKeys,halfCheckedNodes,halfCheckedKeys){
      let arr =  checkedKeys.halfCheckedKeys
      let array = arr.concat(checkedKeys.checkedKeys)
      this.CurrentosData = array
    },

    modification(){
      if(this.title == "添加角色"){
      let obj = {
        "roleOfficeId":this.office.officeId, // 归属机构
        "roleName":this.roleName, // 角色名称
        "dataScope":this.dataScopeS, // 数据范围
        "menus":this.CurrentMenu,
        "offices":this.CurrentosData
      }
      this.$http.post(this.$requestUrl.POST_ADD_ROLE,obj).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          this.dialogVisible = false
          this.$emit("Visible",false)
        } else {
          this.$message.error(result.msg)
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
      }else{
      let obj = {
        "roleOfficeId":this.formLabelAlign.row.roleOfficeId, // 归属机构
        "roleName":this.roleName, // 角色名称
        "dataScope":this.dataScopeS, // 数据范围
        "menus":this.CurrentMenu,
        "offices":this.CurrentosData,
        "roleId":this.formLabelAlign.row.roleId
      }
      this.$http.put(this.$requestUrl.GET_ROLE_AMEND,obj).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          this.dialogVisible = false
          this.$emit("Visible",false)
        } else {
          this.$message.error(result.msg)
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
      }
    },
    dataScopeChange(value){
      if(value == "9"){
        this.dataScopeIf = true
      }else{
        this.dataScopeIf = false
      }
    },
    getMsgFormSon(data){
        this.office = data
        this.affiliation = data.officeName
    },
    handleChange(){
      this.$refs.RoleManagementOneDialog.titl = "配置";
      this.$refs.RoleManagementOneDialog.dialogVisi = true;
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    amend(){
    }
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {

  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>